module.exports = __webpack_public_path__ + "img/GH-kyujin-top-008.674a144e.webp";